var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.65,
    height: 37.977,
    viewBox: "0 0 37.65 37.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3711",
    "data-name": "Ellipse 3711",
    cx: 8,
    cy: 8.5,
    rx: 8,
    ry: 8.5,
    transform: "translate(7)",
    fill: "#1a8fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M19.044,26.53a4.139,4.139,0,0,1,.335-4.623,4.138,4.138,0,0,1-.335-4.623l1.336-2.312a4.14,4.14,0,0,1,3.576-2.064,4.2,4.2,0,0,1,.6.043,4.286,4.286,0,0,1,.192-.391A7.788,7.788,0,0,0,21.878,12H7.843A7.852,7.852,0,0,0,0,19.843v5.779A1.239,1.239,0,0,0,1.238,26.86h18Z",
    transform: "translate(0 7.814)",
    fill: "#1a8fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M27.24,22.03a6,6,0,0,0,.078-.774,6.275,6.275,0,0,0-.078-.774l1.488-1.126a.826.826,0,0,0,.216-1.072l-1.336-2.312a.826.826,0,0,0-1.035-.348l-1.712.722a6.135,6.135,0,0,0-1.352-.8l-.228-1.818A.827.827,0,0,0,22.462,13h-2.67a.826.826,0,0,0-.819.723l-.228,1.818a6.161,6.161,0,0,0-1.352.8l-1.712-.722a.824.824,0,0,0-1.035.348L13.31,18.284a.827.827,0,0,0,.216,1.072l1.488,1.126a6,6,0,0,0-.078.774,6.275,6.275,0,0,0,.078.774l-1.488,1.126a.826.826,0,0,0-.216,1.072l1.336,2.313a.826.826,0,0,0,1.035.348l1.712-.723a6.135,6.135,0,0,0,1.352.8l.228,1.818a.824.824,0,0,0,.817.723h2.67a.826.826,0,0,0,.819-.723l.228-1.818a6.161,6.161,0,0,0,1.352-.8l1.712.722a.824.824,0,0,0,1.035-.348l1.336-2.313a.827.827,0,0,0-.216-1.072Zm-6.114,2.528a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,21.126,24.558Z",
    transform: "translate(8.595 8.465)",
    fill: "#1a8fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUser);
export default __webpack_public_path__ + "static/media/manage_user.6fe37485cbd850f2891b3150cd19eacd.svg";
export { ForwardRef as ReactComponent };